import { IPotentialChip } from "core-integration/src/store/chips/types";
import ChevronRightIcon from "plos/src/img/icons/chevron-right.svg?react";
import { rtlRotate180 } from "plos/src/styles/utils.css";
import { Button } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { getShortNameFromId } from "../../../utils/events";
import ChipBadge from "../ChipBadge";
import {
  cardStyles,
  chipActionLabel,
  chipButtonStyles,
  chipTitle,
  labelWrapper,
} from "./chipCard.css";

interface ChipChardProps {
  onClick?: () => void;
  title: string;
  chip: IPotentialChip;
  variant?: "responsive" | "default";
}

const ChipCard = ({
  chip,
  onClick,
  title,
  variant = "default",
}: ChipChardProps) => {
  const { t } = useTranslation("chips");
  const chipLabelText = () => {
    switch (chip.status_for_entry) {
      case "unavailable":
        return t("label.unavailable", "Unavailable");
      case "proposed":
        return t("label.pending", "Pending");
      case "active":
        if (chip.is_pending) {
          return t("label.pending", "Pending");
        }
        return t("label.active", "Active");
      case "cancelled":
      case "available":
        return t("label.play", "Play");
      case "played": {
        const eventsPlayed = chip.played_by_entry.map((id) =>
          getShortNameFromId(id, true),
        );
        return eventsPlayed.length > 1
          ? t("label.playedMultiple", "Played {{events}}", {
              events: eventsPlayed.join(", "),
            })
          : t("label.playedSingle", "Played GW{{event}}", {
              event: eventsPlayed[0],
            });
      }
      default:
        return "";
    }
  };
  const chipIsUnavailable = chip.status_for_entry === "unavailable";
  const chipLabel = chipLabelText();
  const buttonStyleVariant = chipIsUnavailable ? "unavailable" : "default";

  return (
    <li
      aria-label={t("label.chipName", "{{title}} chip", { title })}
      className={cardStyles[variant]}
    >
      <Button
        className={chipButtonStyles[buttonStyleVariant]}
        onPress={onClick}
        isDisabled={chipIsUnavailable}
      >
        <ChipBadge path={`/img/chips/${chip.name}`} sizes={"24px"} />
        <span className={chipTitle}>{title}</span>
        <span className={labelWrapper}>
          <span className={chipActionLabel[chip.status_for_entry]}>
            {chipLabel}
          </span>
          {chip.status_for_entry === "played" && (
            <ChevronRightIcon
              aria-hidden
              width={10}
              height={10}
              className={rtlRotate180}
            />
          )}
        </span>
      </Button>
    </li>
  );
};

export default ChipCard;
